<template>
  <form-item-wrapper class="vform" :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div class="select_flex">
      <el-select ref="fieldEditor" v-model="fieldModel" v-show="!isReadMode" :class="{'full-width-input': true}"
        :disabled="field.options.disabled" :clearable="field.options.clearable" :size="field.options.size"
        :filterable="field.options.filterable" :allow-create="field.options.allowCreate"
        :default-first-option="allowDefaultFirstOption" :automatic-dropdown="field.options.automaticDropdown"
        :multiple="field.options.multiple" :multiple-limit="field.options.multipleLimit" :placeholder="field.options.placeholder || i18nt('render.hint.selectPlaceholder')
          " :remote="field.options.remote" :remote-method="remoteQuery" @focus="onFocus"
        @blur="handleBlurCustomEvent" @change="handleChangeEvent" :style="myStyles" :popper-class="fixedHeightOptions[field.options.fixedHeight]">
        <el-option v-for="item in field.options.optionItems" :key="item.value" :label="item.label" :value="item.value + ''"
          :disabled="item.disabled">
        </el-option>
      </el-select>
      <div v-if="field.options.buttonText" class="append" :style="{ height: appendHeight + 'px' }">{{field.options.buttonText}}</div>

    </div>
    <template v-if="isReadMode">
      <span class="readonly-mode-field">{{ optionLabel }}</span>
    </template>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "./form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";

export default {
  name: "select-widget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  components: {
    FormItemWrapper,
  },
  inject: ["refList", "globalOptionData", "globalModel"],
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],
      debounceTimer: null,
      appendHeight:0,
      fixedHeightOptions:{
        '1':'show5',
        '2':'show10',
        '3':'show15',
        '4':'unset'
      },
    };
  },
  computed: {
    allowDefaultFirstOption() {
      return (
        !!this.field.options.filterable && !!this.field.options.allowCreate
      );
    },
    myStyles() {
      return {
        'font-size': this.getFormConfig().fontSize + '!important',
        'font-weight': this.getFormConfig().fontWeight + '!important'
      }
    },
  },
  beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },
  watch: {
    'field.options.optionItems': {
      handler(n) {
        let defaultValue = this.field.options.defaultValue
        if (!defaultValue) return
        if (this.field.options.multiple && defaultValue && typeof defaultValue === 'string') {
          this.fieldModel = defaultValue.split(',')
        }
        this.initEventHandler();
      }, deep: true
    },
    'field.options.defaultValue': {
      handler(n) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          if (this.field.options.multiple) {
            this.field.options.defaultValue = !this.field.options.defaultValue ? [] : this.field.options.defaultValue.split(',');
          }
        }, 500);
      }
    },
  },
  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initOptionItems();
    this.initFieldModel();
    this.initEventHandler();
    this.buildFieldRules();

    this.handleOnCreated();
  },

  mounted() {
    this.handleOnMounted();
    const selectElement = this.$refs.fieldEditor.$el; // 获取 el-select 的 DOM 元素
    if (selectElement) {
      this.appendHeight = selectElement.offsetHeight; // 获取高度并设置给 append
    }
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },

  methods: {
    onFocus() {
        // this.$nextTick(() => {
        //   const dropdownWrap = document.querySelector('.fixed .el-select-dropdown__wrap');
        //   console.log(dropdownWrap);
        //   if (dropdownWrap) {
        //     dropdownWrap.style.maxHeight = this.field.options.fixedHeight? '150px':'unset!important';  // 设置新的最大高度
        //   }
        // });
    },
    change() {
      // console.log(this.field.options.multiple);
      // console.log(this.value1);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/global.scss"; //* form-item-wrapper已引入，还需要重复引入吗？ *//

.full-width-input {
  width: 100% !important;
}

::v-deep .el-select__tags {
  flex-wrap: nowrap !important;
  overflow: hidden !important;
}
</style>
<style lang="scss">
.el-select-dropdown__item {
  font-size: 16px !important;
}
.fixed {
  .el-scrollbar {
    height: 100%;
    .el-select-dropdown__wrap {
      overflow-x: hidden;
      max-height: unset!important;
    }
  }
}
.show5{
  .el-select-dropdown__wrap {
    max-height: 188px!important;
  }
}
.show10{
  .el-select-dropdown__wrap {
    max-height: 356px!important;
  }
}
.show15{
  .el-select-dropdown__wrap {
    max-height: 530px!important;
  }
}
.unset{
  .el-select-dropdown__wrap {
    max-height: unset!important;
  }
}
.append{
  background-color: #F5F7FA;
  color: #909399;
  vertical-align: middle;
  display: table-cell;
  position: relative;
  border: 1px solid #c3c3c3;
  // border-radius: 4px;
  padding: 0 20px;
  white-space: nowrap;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  margin-left: -2px;
  // line-height: 34px;
}
.select_flex{
  display: flex;
  align-items: center;
}
</style>
